export function Logo({ size = 48, className = "", showText = false }) {
  return (
    <div className={`inline-flex items-center gap-2 ${className}`} data-testid="app-logo">
      <img
        src="/logo-acerto.png"
        alt="Acerto Rápido JVO"
        width={size}
        height={size}
        style={{ width: size, height: size, objectFit: "contain" }}
        className="rounded-xl shadow-sm"
        draggable={false}
      />
      {showText && (
        <div className="leading-tight">
          <div className="font-extrabold tracking-tight text-blue-900 dark:text-blue-100 text-[13px]" style={{ fontFamily: "Manrope, sans-serif" }}>
            ACERTO RÁPIDO
          </div>
          <div className="text-[10px] tracking-[0.3em] text-blue-700/80 dark:text-blue-300 font-semibold">JVO</div>
        </div>
      )}
    </div>
  );
}
